import commonSaga from './Common';
import dashboardSaga from './Dashboard';
import datacenterSaga from './Datacenters';
import environmentsSaga from './Environments';
import requestsSaga from './Requests';
import settingsSaga from './Settings';
import systemSaga from './System';
import environmentWorkflowSaga from './workflows/EnvironmentWorkflow';
import upgradeWorkflowSaga from './workflows/UpgradeWorkflow';

export const lcopsSagas = () => [
  dashboardSaga(),
  environmentWorkflowSaga(),
  datacenterSaga(),
  settingsSaga(),
  commonSaga(),
  environmentsSaga(),
  requestsSaga(),
  upgradeWorkflowSaga(),
  systemSaga()
];

export default lcopsSagas;
